/**
 * Lightweight event bus for the global "upgrade required" upsell modal.
 *
 * The HTTP client's 402 interceptor dispatches `billing:upgrade-required`
 * (see src/lib/http-client.ts), and the globally-mounted <UpgradeDialog />
 * subscribes to it. Decoupling via a window CustomEvent keeps the low-level
 * HTTP layer free of React/router dependencies.
 */
export const UPGRADE_REQUIRED_EVENT = 'billing:upgrade-required';

export interface UpgradeRequiredDetail {
    feature: string;
    requiredPlan: string | null;
    ownerType: string;
    ownerId: string;
    message: string;
}

export function dispatchUpgradeRequired(detail: UpgradeRequiredDetail): void {
    window.dispatchEvent(new CustomEvent<UpgradeRequiredDetail>(UPGRADE_REQUIRED_EVENT, { detail }));
}

export function subscribeUpgradeRequired(
    handler: (detail: UpgradeRequiredDetail) => void,
): () => void {
    const listener = (event: Event) => {
        handler((event as CustomEvent<UpgradeRequiredDetail>).detail);
    };
    window.addEventListener(UPGRADE_REQUIRED_EVENT, listener);
    return () => window.removeEventListener(UPGRADE_REQUIRED_EVENT, listener);
}
